/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    createReducer,
    on,
} from '@ngrx/store';
import {
    cancelLoading,
    clearLoadingError,
    loadSystemInfo,
    setAllowReload,
    systemInfoLoadFailure,
    systemInfoLoadSuccess,
} from './system-info.actions';
import {
    initialSystemInfoState,
    ISystemInfoState,
} from './system-info.state';

export const systemInfoReducer = createReducer(
    initialSystemInfoState,
    on(
        loadSystemInfo,
        (state: ISystemInfoState): ISystemInfoState => {
            return {
                ...state,
                loading: true,
            };
        },
    ),
    on(
        systemInfoLoadSuccess,
        (state: ISystemInfoState, { systemInfo }): ISystemInfoState => {
            return {
                ...state,
                ...systemInfo,
                loading: false,
                loaded: true,
                loadingError: null,
                allowReload: false,
            };
        },
    ),
    on(
        systemInfoLoadFailure,
        (state: ISystemInfoState, { error }): ISystemInfoState => {
            return {
                ...state,
                loading: false,
                loaded: false,
                loadingError: error,
                allowReload: true,
            };
        },
    ),
    on(
        setAllowReload,
        (state: ISystemInfoState, { allowReload }): ISystemInfoState => {
            return {
                ...state,
                allowReload,
            };
        },
    ),
    on(
        clearLoadingError,
        (state: ISystemInfoState): ISystemInfoState => {
            return {
                ...state,
                loadingError: null,
            };
        },
    ),
    on(
        cancelLoading,
        (state: ISystemInfoState): ISystemInfoState => {
            return {
                ...state,
                loading: false,
            };
        },
    ),
);
